import { ModulesCards, ModulesList } from "../../../types/CoursesTypes";

import CardModules from "../../templates/CoursesPage/CardModules";
import Modules from "../../templates/CoursesPage/Modules/Modules";

export const renderModules = (
  moduleData: ModulesList | ModulesCards | undefined,
  extraProps?: { styleClass?: string },
) => {
  if (!moduleData) return null;

  if ("list" in moduleData && moduleData.list) {
    return <Modules data={moduleData as ModulesList} {...extraProps} />;
  }

  if ("cards" in moduleData && moduleData.cards) {
    return <CardModules data={moduleData as ModulesCards} />;
  }

  return null;
};

export const normalizeTitle = (title: string) => {
  return title
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ç/g, "c")
    .replace(/^\d+/, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
